import React from 'react';
import classNames from 'classnames';
import { Button, Icon } from '@/components/shared';
import { DrawerMegaMenuItem } from '@/types/drawerMegaMenuItem';
import styles from './DesktopMainMenu.module.scss';

interface DesktopMainMenuProps {
	megaMenu?: DrawerMegaMenuItem[];
	activeItem?: number;
	openSubmenu: (index: number) => void;
	closeDrawer?: () => void;
}

export const DesktopMainMenu: React.FunctionComponent<DesktopMainMenuProps> = ({
	megaMenu,
	activeItem,
	openSubmenu,
	closeDrawer,
}) => {
	return (
		<ul className={styles.list}>
			{megaMenu?.map((item, index) => {
				const internalLink = item.internalLink || item.route?.externalRoute;
				// Categories without subcategories have nothing to show in the second level,
				// so they link straight to their own page instead of opening an empty panel.
				// Categories linking to the application solution builder still have the segment
				// bar to show, so they keep opening the panel even without subcategories.
				const isLink =
					!item.children?.length && !item.showLinkToSelector && Boolean(internalLink || item.externalLink);

				return (
					<li className={styles.item} key={`${index}-${item.name}`}>
						{isLink ? (
							<Button
								className={styles.itemButton}
								variant={'ghost'}
								isFullWidth
								to={internalLink}
								state={item.route}
								href={item.externalLink}
								target={!internalLink && item.externalLink ? '_blank' : undefined}
								onClick={closeDrawer}
							>
								<span>{item.name}</span>
							</Button>
						) : (
							<Button
								className={classNames(styles.itemButton, {
									[styles.isActive]: activeItem === index,
								})}
								variant={'ghost'}
								isFullWidth
								onClick={(): void => {
									openSubmenu(index);
								}}
								// The open panel is otherwise only marked visually
								aria-expanded={activeItem === index}
							>
								<span>{item.name}</span>
								<Icon name={'chevronDown'} size={'md'} rotate={'270'} />
							</Button>
						)}
					</li>
				);
			})}
		</ul>
	);
};
